import React from "react";

import images from "../../../assets";
import MainSidebar from "./mainsidebar";
import SearchField from "./searchfield";

import NotificationDropdownContainer from "./notifidropdown/notificationdropdowncontainer";
import ProfileDropdownContainer from "./profiledropdown";

const Navbar = () => {
  return (
    <div className="header">
      <div className="flex gap-3 items-center w-full">
        <MainSidebar />
        <SearchField />
      </div>
      <div className="header-notification">
        <NotificationDropdownContainer />
      </div>
      <ProfileDropdownContainer />
    </div>
  );
};

export default Navbar;
